var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInput',{style:({
    width: '100px',
  }),attrs:{"value":_vm.value,"default-value-when-empty":_vm.defaultValueWhenEmpty,"type":"number","remove-number-input-controls":"","to-value":(value) => (value ? parseInt(value) : null)},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":function($event){return _vm.$emit('blur')}},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_vm._v("px")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }